module.exports = __webpack_public_path__ + "static/media/Window frame.d412590d.jpg";